import Gallery from "../blocks/gallery";

const SinglePost = {
  init() {
    SinglePost.events();
    new Gallery('.gallery');
  },

  events() {

  },
};

export default SinglePost;
